import { SEO } from "@/components/SEO";
import { Navbar } from "@/components/Navbar";
import { SolutionTabsSection } from "@/components/SolutionTabsSection";
import { ShippingOperationsSection } from "@/components/ShippingOperationsSection";
import { AITechSection } from "@/components/AITechSection";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "@/lib/router-compat";

const Solutions = () => {
  const { language } = useLanguage();
  const prefix = language === "en" ? "" : `/${language}`;
  const fmsLabel =
    language === "zh"
      ? "什么是 FMS 系统 / AI FMS 平台？"
      : language === "th"
        ? "ระบบ FMS และแพลตฟอร์ม AI FMS คืออะไร?"
        : "What is an FMS system / AI FMS platform?";

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Freight Forwarding System & Platform | CargoNova"
        description="AI-native freight forwarding system and freight forwarder platform for air, ocean and multimodal operators — digital forwarding software that cuts costs 25%+."
        canonical="https://cargonova.ai/solutions"
        titleZh="货代系统与数字货代平台：海运 空运 多式联运 | CargoNova"
        descriptionZh="面向海运、空运与多式联运的货代系统与数字货代平台，基于国际货代 AI 系统，覆盖中小型到全球型货代，AI 驱动降低 25%+ 物流成本。"
        canonicalZh="https://cargonova.ai/zh/solutions"
        canonicalTh="https://cargonova.ai/th/solutions"
      />

      <Navbar />
      <main className="pt-20">
        <SolutionTabsSection />
        <ShippingOperationsSection />
        <AITechSection />
        <div className="container mx-auto px-4 pb-12 text-center">
          <Link
            to={`${prefix}/blog/what-is-ai-fms`}
            className="text-sm font-medium text-muted-foreground hover:text-secondary transition-colors"
          >
            {fmsLabel}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Solutions;
